import { Box, Tab, Tabs } from "@mui/material";

const EntityTabs = ({ editableEntityData, tabIndex, handleTabChange }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
                TabIndicatorProps={{
                    style: {
                        backgroundColor: '#000',
                        height: 2,
                    },
                }}
            >
                <Tab label="Basic"
                    sx={{
                        color: '#555',
                        '&.Mui-selected': {
                            color: '#000',
                            fontWeight: 'bold',
                        },
                        textTransform: 'none',
                        fontSize: '14px',
                        mx: 2, // optional spacing
                    }}
                />

                {editableEntityData?._id && <Tab label="Multimedia"
                    sx={{
                        color: '#555',
                        '&.Mui-selected': {
                            color: '#000',
                            fontWeight: 'bold',
                        },
                        textTransform: 'none',
                        fontSize: '14px',
                        mx: 2, // optional spacing
                    }}
                />}
            </Tabs>
        </Box>
    );
}

export default EntityTabs;